<div class="pull-to-refresh" #content (scroll)="setScrollY($event)" (touchstart)="touchStart($event)" (touchmove)="touchEnd($event)">
    <div class="flex justify-center items-center loader shrink-0 overflow-hidden transition-all"
         [class.h-16]="refreshing"
         [class.h-0]="!refreshing">
        <app-spinner></app-spinner>
    </div>

    <ng-content></ng-content>
</div>
